import { Placement, VirtualElement } from '@popperjs/core';
import React, { CSSProperties, FC, useCallback } from 'react';
import { Portal } from './Portal';
import { usePopper } from 'react-popper';

interface IOverlayProps {
  onClick: (ev: React.MouseEvent) => void;
}

export const Overlay: FC<IOverlayProps> = (props) => {
  return (
    <div className="absolute inset-0 z-[1999]" onClick={props.onClick}></div>
  );
};

interface IDialogBodyProps {
  style?: CSSProperties;
  attributes?: { [key: string]: string };
}

export const DialogBody = React.forwardRef<
  any,
  React.HTMLProps<HTMLDivElement> & IDialogBodyProps
>(({ children, style, attributes }, ref) => {
  return (
    <div
      style={{
        ...style,
        zIndex: 2000,
      }}
      {...attributes}
      ref={ref}
      className="w-60 rounded border rounded border border-grey-50 bg-grey-900 shadow-2xl"
      data-cy="dialogBody"
    >
      {children}
    </div>
  );
});

interface IDialogProps {
  isOpen: boolean;
  onClose?: () => void;
  referenceElement: Element | VirtualElement | null | undefined;
  placement?: Placement;
}

export const Dialog: FC<IDialogProps> = ({
  referenceElement,
  placement,
  isOpen,
  children,
  onClose,
}) => {
  const [popperElement, setPopperElement] =
    React.useState<HTMLDivElement | null>(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: placement || 'bottom-start',
  });

  const close = useCallback(() => {
    if (onClose) onClose();
  }, [onClose]);

  return isOpen ? (
    <Portal>
      <Overlay onClick={() => close()} />
      <DialogBody
        ref={setPopperElement}
        style={styles.popper}
        attributes={attributes.popper}
      >
        {children}
      </DialogBody>
    </Portal>
  ) : null;
};
